import { render } from "./ScreenOne.vue?vue&type=template&id=8a843b5e&scoped=true&class=app"
import script from "./ScreenOne.vue?vue&type=script&lang=js"
export * from "./ScreenOne.vue?vue&type=script&lang=js"

import "./ScreenOne.vue?vue&type=style&index=0&id=8a843b5e&scoped=true&lang=css"

import exportComponent from "/Users/ashrock_m13/Ashrockzzz/git_amrita/virtuallab-oop/exp-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a843b5e"]])

export default __exports__